import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam';

const serverUrl = publishObjectPath.serverUrl;
const loginHeaders: any = {
  Accept: 'application/json; charset=UTF-8',
  'Content-Type': 'application/json; charset=UTF-8',
};

export class LoginServe {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 获取验证码
  public getValidatorCode() {
    const url = serverUrl + '/api/user/verificationCode';
    return this.rSerivce.serverObj.get(url);
  }

  // 发起登录请求
  public userLogin(opts: any) {
    const url = serverUrl + '/api/user/encipher/doLogin';
    return this.rSerivce.serverObj.post(url, opts, { headers: loginHeaders });
  }
}
